<template>
  <div class="agent-info-page">
    <div class="head_area">
      <div class="leftImg">
        <img @click="back" src="/static/image/icon-jiantou@2x.eb0b501e01e95b720b727b63a23960e3.png" class="top_back">
      </div>
      <span class="head_text">个人信息</span>
      <span class="right_menu"></span>
    </div>
    <div class="content">
      <div class="info-list">
        <div class="info-item">
          <div class="label">我的余额:</div>
          <div class="value">{{ info.balance || 0.00 }}</div>
        </div>
        <div class="info-item">
          <div class="label">下属代理:</div>
          <div class="value">{{ info.sub_agents || 0}}</div>
        </div>
        <div class="info-item">
          <div class="label">直属玩家:</div>
          <div class="value">{{ info.direct_players || 0 }}</div>
        </div>
        <div class="info-item">
          <div class="label">今日投注:</div>
          <div class="value">{{ info.today_bet || 0.00}}</div>
        </div>
        <div class="info-item">
          <div class="label">今日收益:</div>
          <div class="value">{{ info.today_profit || 0.00 }}</div>
        </div>
        <div class="info-item">
          <div class="label">历史收益:</div>
          <div class="value">{{ info.history_profit || 0.00 }}</div>
        </div>
        <div class="info-item">
          <div class="label">邀请码:</div>
          <div class="value">{{info.invite_code || ''}}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {translateText} from "../../common/utils";

export default {
  name: 'agent-info',
  data(){
    return {
      info: {}
    }
  },
  mounted() {
    this.getAgentInfo()
  },
  methods: {
    back(){
      window.history.go(-1)
    },
    async showTost(type, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    getAgentInfo(){
      this.$apiFun
        .post('/api/profile', {})
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.message);
          }
          if (res.code === 200) {
            this.info = res.data;
          }
        })
        .catch(res => {
        });
    }

  },
}
</script>

<style scoped lang="scss">
.agent-info-page {
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction:column;
  overflow: hidden;
  background: #F1F1F1;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    background: linear-gradient( 90deg, #3A8AFF 0%, #89AAFF 100%);
    .leftImg {
      flex: 1;
      text-align: right;
      transform: rotate(180deg);
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.43rem;
      font-weight: bold;
      font-family: PingFang SC;
      color: #fff;
      width: 80%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      font-family: PingFang SC;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }

  .content {
    flex: 1;
    overflow: auto;
    position: relative;
    z-index: 2;
    padding: .24rem .36rem;
    .info-list {
      background: #FFFFFF;
      border-radius: .24rem;
      padding: 0 .24rem;
      overflow: hidden;
      .info-item {
        height: .9rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 0.02rem solid #F0F0F0;
        &:last-child {
          border-bottom: none;
        }
        .label {
          color: #666666;
          font-size: 0.29rem;
          width: 3.4rem;
        }
        .value {
          flex: 1;
          font-size: 0.34rem;
          font-family: Gilroy, Gilroy;
          text-align: right;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agent/info.vue